export class ActionTriggerHarnessController {
  public triggerText = "Action Trigger";
  private triggerClicks = 0;
  public isDisabled = true;
  // @ngInject
  constructor(private $element: ng.IAugmentedJQuery) {}

  public triggerClicked() {
    if (this.triggerClicks == 0) {
      this.triggerText = "Ow!";
    } else if (this.triggerClicks == 1) {
      this.triggerText = "Stop it!";
    } else {
      this.triggerText += "!";
    }
    this.triggerClicks++;
  }
}
